import { BrainCircuit } from "lucide-react";

export default function Brand({ className = "", light = false }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="w-9 h-9 rounded-xl bg-primary flex items-center justify-center shrink-0">
        <BrainCircuit className="w-5 h-5 text-white" aria-hidden="true" />
      </div>
      <div className="leading-tight">
        <div className={`font-heading font-semibold text-[15px] ${light ? "text-white" : "text-slate-900 dark:text-white"}`}>
          Teraviva
        </div>
        <div className={`text-[10px] tracking-wide ${light ? "text-white/70" : "text-muted-foreground"}`}>
          Terapia + vida, evolução
        </div>
      </div>
    </div>
  );
}
